/**
 * Find-the-best-weapon runs as a tournament instead of one shared search.
 *
 * The weapon decides what every other item is worth, and one search that
 * changes weapon and gear together settles on whatever element it leaned
 * towards first: on a real request every seed ended on the same air build at
 * 732 damage a turn while a water one reached 844. So every (weapon, forging)
 * gets a quick estimate, the best few are searched with their weapon held,
 * and each round keeps a quarter of them for a longer search.
 *
 * How many is the budget's call, not a constant: a candidate needs some
 * search before its score means anything, so the first round takes as many as
 * get `TOURNAMENT_WORKER_SECONDS_EACH` of it — about 150k evaluations at the
 * ~180k/s a browser worker measured — at least `TOURNAMENT_ROUND_MIN[0]`, at
 * most `TOURNAMENT_MAX_WIDTH`. Eight workers for 10 s keep 29; one keeps 4. Measured
 * over 1-8 workers and 5-20 s on two requests against the fixed 32 / 8 / 2
 * this replaced: 96.2% -> 97.6% and 97.9% -> 98.7% of the best build known,
 * and four workers found the best in 5 s where fixed widths needed 8 and 20 s.
 *
 * `TOURNAMENT_SHARES` is the share of the search time each round gets.
 */
export const TOURNAMENT_SHARES = [0.3, 0.3, 0.4];
const TOURNAMENT_WORKER_SECONDS_EACH = 0.83;
const TOURNAMENT_MAX_WIDTH = 32;
/**
 * Each round keeps this fraction of the last, never fewer than its minimum.
 * Two finalists, not one: with a single one, a weapon picked wrongly after a
 * short round has nothing left to beat it (one run ended at 630 a turn where
 * the same request reaches 844).
 */
const TOURNAMENT_KEEP = 0.25;
const TOURNAMENT_ROUND_MIN = [4, 2, 2];

/**
 * How many candidates each round searches, for `islands` workers and
 * `searchMs` of search: see `TOURNAMENT_WORKER_SECONDS_EACH`.
 */
export function tournamentWidths(islands, searchMs) {
    const firstSeconds = Math.max(1, islands) * (searchMs / 1000) * TOURNAMENT_SHARES[0];
    const first = Math.round(firstSeconds / TOURNAMENT_WORKER_SECONDS_EACH);
    const widths = [Math.min(TOURNAMENT_MAX_WIDTH, Math.max(TOURNAMENT_ROUND_MIN[0], first))];
    for (let r = 1; r < TOURNAMENT_SHARES.length; r += 1) {
        widths.push(Math.max(TOURNAMENT_ROUND_MIN[r], Math.floor(widths[r - 1] * TOURNAMENT_KEEP)));
    }
    return widths;
}
